import React, { useEffect, useRef, useState } from "react";
import "./iconAnswer.css";
import iconAnswer from "../../assets/svgs/iconAnswer.svg";

interface IconAnswerProps {
  message: string;
}

const IconAnswer = ({ message }: IconAnswerProps) => {
  const [showMessage, setShowMessage] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setShowMessage((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShowMessage(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderMessage = () => {
    const replaceTags = (text: string) => {
      return text
        .replaceAll(/<b>(.*?)<\/b>/g, "<strong>$1</strong>")
        .replaceAll("<br/>", "<br />");
    };

    return <div dangerouslySetInnerHTML={{ __html: replaceTags(message) }} />;
  };

  return (
    <div className="containerIconAnswer" ref={containerRef}>
      <button
        type="button"
        onClick={handleClick}    
        className="iconAnswerButton"  
        aria-label="O que é o favorito?"
      >
        <img
          src={iconAnswer}
          alt="O que é o favorito?"
          className="iconAnswerImg"
          style={{ width: "25px" }}
        />
      </button>
      {showMessage && (
        <span className="mensageIconAnswer" style={{ marginTop: "5px" }}>
          {renderMessage()}
        </span>
      )}
    </div>
  );
};

export default IconAnswer;
